<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-narrow has-text-centered">
        <img
          src="/img/error-404.png"
          alt="">
        <h1 class="is-margin-top has-text-centered is-size-6 has-text-grey">
          <i>La page demandée n'est pas disponible ou n'existe pas.</i>
        </h1>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NotFound',
  created () {
    this.$notify({
      type: 'is-danger',
      text: 'La page demandée n\'est pas disponible ou n\'existe pas.'
    })
  }
}
</script>
